import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {ProductDto, QuotationControllerService, QuotationDto, QuotationLineDto, RfqDto} from '../../@api';
import {environment} from '../../../environments/environment';
import {StatePersistenceService} from '../../service/state.persistence.service';

interface Customer {
    name: string;
    email: string;
    phone: string;
}

@Component({
    selector: 'quote-view',
    templateUrl: './quote-view.component.html',
    styleUrls: ['./quote-view.component.scss']
})
export class QuoteViewComponent implements OnInit {

    customer: Customer = {
        name: 'Ramon Fourie',
        email: 'ramon.fourie@sicl.co',
        phone: '0826295223'
    };

    quotation: QuotationDto = {};

    constructor(@Inject(DOCUMENT) public document: Document,
                private router: Router,
                private route: ActivatedRoute,
                private quotationService: QuotationControllerService,
                private state: StatePersistenceService) {
        state.headerCss = 'display-none';
    }

    ngOnInit(): void {
        // Option 1: Using snapshot for one-time access
        let quoteNumber: string | null = this.route.snapshot.queryParamMap.get('number');
        let uid: number | null = +this.route.snapshot.queryParamMap.get('uid');

        let request: QuotationDto = { id: uid, number: quoteNumber}
        this.quotationService.findQuotationByNumberAndId(request).subscribe((response: QuotationDto): void => {
            this.quotation = response;
            console.log('this.quotation.rfqUid: ' + this.quotation.rfqUid);
            this.quotationService.findRfqByUid(this.quotation.rfqUid).subscribe((rfqResponse: RfqDto): void => {
                this.customer = {
                    name: rfqResponse.fullName,
                    email: rfqResponse.email,
                    phone: rfqResponse.phone
                };
            });
        }, error => {
            console.log(error);
        });
    }
    
    productUri(product: ProductDto): string {
        return String().concat(environment.baseUrl, '/', product.category.toLowerCase(), '/', product.root);
    }

    imageUri(product: ProductDto): string {
        const brand: string = product.brand.toLowerCase().replaceAll(' ', '-');
        return String().concat('https://www.solarcentral.co.za/images/', brand, '.png');
    }

    requested(quotation: QuotationDto): QuotationLineDto[] {
        return quotation.lines?.filter((f: QuotationLineDto) => !f.recommended);
    }

    recommended(quotation: QuotationDto): QuotationLineDto[] {
        return quotation.lines?.filter((f: QuotationLineDto) => f.recommended);
    }
}